import { injectable, inject } from 'inversify';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher, DITypes } from '@condor/json-rpc-dispatcher';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import CookieRepository from '@framework/browser/storage/CookieRepository';
import { CLOSED_HEADER_BANNERS_COOKIE_NAME } from '@framework/ui/Organisms/HeaderBanner/contants';

@injectable()
class BannersRepository {
  constructor(
    @inject(DITypes.JsonRpcDispatcher) private readonly condorRpc: IDispatcher,
    @inject(CookieRepository) private readonly cookiesRepository: CookieRepository,
  ) {}

   async getBannerByTenant(payload = {}) {
    let request = new Request('condor.banner.get_banner_by_tenant', payload);
    let response = await this.condorRpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  }

  list = async (payload = {}) => {
    let request = new Request('condor.banner.get_banners', payload);
    let response = await this.condorRpc.call<RpcSuccess>(request);

    return response.getResult().payload;
  };

  positionsList = async (payload = {}) => {
    let request = new Request('condor.banner.get_positions', payload);
    let response = await this.condorRpc.call<RpcSuccess>(request);
    return response.getResult().payload;
  };

  create = async (payload = {}) => {
    const req = new Request('condor.banner.create_banner', payload);
    const response = await this.condorRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  update = async (payload = {}) => {
    const req = new Request('condor.banner.update_banner', payload);
    const response = await this.condorRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  delete = async (payload = {}) => {
    const req = new Request('condor.banner.delete_banner', payload);
    const response = await this.condorRpc.call<RpcSuccess>(req);

    return response.getResult().payload;
  };

  getClosedBanners = async () => {
    return (await this.cookiesRepository.get(CLOSED_HEADER_BANNERS_COOKIE_NAME))?.split(',') || [];
  };

  setClosedBanners = async (hash: string) => {
    const closedBanners = await this.getClosedBanners();
    if (closedBanners.length >= 5) {
      closedBanners.shift();
      closedBanners.push(hash);
    } else {
      closedBanners.push(hash);
    }
    this.cookiesRepository.set(CLOSED_HEADER_BANNERS_COOKIE_NAME, closedBanners.join(','), {
      domain: '',
      expires: 365,
    });
  };
}

export default BannersRepository;
